import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ExcelUploadServices from "./ExcelUpload.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const saveExcelUpload = (req, setShowModal) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EXCEL_UPLOAD,
      payload: true,
    });
    await ExcelUploadServices.saveExcelUpload(req);
    dispatch({
      type: actions.EXCEL_UPLOAD_FAIL,
      payload: null,
    });
    setShowModal();
    toastr.success(messages.fileSuccessMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EXCEL_UPLOAD_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EXCEL_UPLOAD,
      payload: false,
    });
  }
};

export const resetExcelUploadError = () => async (dispatch) => {
  dispatch({
    type: actions.EXCEL_UPLOAD_PROBLEMS,
    payload: [],
  });
  dispatch({
    type: actions.EXCEL_UPLOAD_FAIL,
    payload: "",
  });
};
